import { SwiperSlide } from "swiper/react";
import { Container, SliceBorder, Title, Carousel } from "../../shared/ui";

import { historyCompany } from "./const/historyCompany";
import { useMediaQuery } from "../../shared/hooks/useMediaQuery";
import { generateMediaQuery } from "../../shared/lib/helpers";
import { MediaQueryProperty, MediaSizeEnum } from "../../shared/constants/media";

import styles from "./CompanyHistory.module.scss";
import type { FC } from "react";

const renderContentItem = (item: { type: string; text: string }, index: number) => {
    switch (item.type) {
        case "heading":
            return (
                <p key={index} className={styles.companyHistory__heading}>
                    {item.text}
                </p>
            );
        case "paragraph":
            return (
                <p
                    key={index}
                    className={styles.companyHistory__paragraph}
                    dangerouslySetInnerHTML={{ __html: item.text.replace(/\n/g, "<br />") }}
                />
            );
        case "listItem":
            return (
                <li
                    key={index}
                    className={styles.companyHistory__listItem}
                    dangerouslySetInnerHTML={{ __html: item.text.replace(/\n/g, "<br />") }}
                />
            );
        default:
            return null;
    }
};

const renderContent = (items: Array<{ type: string; text: string }>) => {
    const content = [];
    let currentListItems: JSX.Element[] = [];

    items.forEach((item, index) => {
        if (item.type === "listItem") {
            currentListItems.push(renderContentItem(item, index) as JSX.Element);
        } else {
            if (currentListItems.length > 0) {
                content.push(
                    <ul key={`ul-${index}`} className={styles.companyHistory__list}>
                        {currentListItems}
                    </ul>,
                );
                currentListItems = [];
            }
            content.push(renderContentItem(item, index));
        }
    });

    if (currentListItems.length > 0) {
        content.push(
            <ul key={`ul-end`} className={styles.companyHistory__list}>
                {currentListItems}
            </ul>,
        );
    }

    return content;
};

export const CompanyHistory: FC = () => {
    const matches = useMediaQuery(generateMediaQuery(MediaQueryProperty.MaxWidth, MediaSizeEnum.sm));

    return (
        <div className={styles.wrapper}>
            <div className={styles.scroll} id="history" />
            {!matches ? (
                <SliceBorder
                    sizeRadius={32}
                    multiplierInside={1}
                    border={{ topRight: "outside-corner-lateral", bottomRight: "inside" }}
                >
                    <Container marginSize="standard">
                        <Title className={styles.companyHistory__title} level={2}>
                            Наша история.
                            <br />
                            30 лет побед.
                        </Title>
                    </Container>
                </SliceBorder>
            ) : (
                <Title className={styles.companyHistory__mobileTitle} level={2}>
                    Наша история.
                    <br />
                    30 лет побед.
                </Title>
            )}

            <Container marginSize="standard" className={styles.companyHistory}>
                <Carousel
                    autoHeight={true}
                    className={styles.companyHistory__carousel}
                    slidesPerView={1}
                    spaceBetween={20}
                    pagination={historyCompany.map((item) => item.year)}
                    navigation="down"
                    colorBackground="#E5E7E8"
                    navigationTheme="light"
                    classNameNavigation={styles.companyHistory__mobileNav}
                    loop={false}
                >
                    {historyCompany.map((item) => (
                        <SwiperSlide className={styles.companyHistory__item} key={item.id}>
                            {matches && (
                                <SliceBorder
                                    className={styles.companyHistory__wrapperYear}
                                    sizeRadius={12}
                                    colorBackground="#E5E7E8"
                                    border={{
                                        bottomRight: "outside-corner-upper",
                                        bottomLeft: "inside",
                                        topLeft: "outside-corner-lateral",
                                    }}
                                >
                                    <Title className={styles.companyHistory__year} level={3}>
                                        {item.year}
                                    </Title>
                                </SliceBorder>
                            )}
                            <img alt={item.year} className={styles.companyHistory__img} src={item.image} />
                            <div className={styles.companyHistory__content}>{renderContent(item.items)}</div>
                        </SwiperSlide>
                    ))}
                </Carousel>
            </Container>
        </div>
    );
};
